import { useEffect } from 'react';
import { filingSupportingDocAPI } from '../../../../../../utilities/api';
import { Filing } from '../../../../../../utilities/interfaces/Filing';
import { filingSupportingDocument } from '../../../../../../utilities/interfaces/FilingSupportingDocument';
import { useNotificationHelper } from '../../../../../../utilities/helpers/NotificationHelper';
import { DocumentType } from '../../../../../../utilities/enums/DocumentType';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { getFilingSupportingDocs } from '../../../../../../features/state/StateFiling-slice';

export const useFilingUploadController = (filing: Filing) => {
  const { addNotification } = useNotificationHelper();
  const filingSupportingDocs = useAppSelector((state) => state.filings.filingSupportingDocs);
  const filingHearingDocs = useAppSelector((state) => state.filings.filingHearingDocs);
  const filingAffidavitDocs = useAppSelector((state) => state.filings.filingAffidavitDocs);
  const filingSummaryDocs = useAppSelector((state) => state.filings.filingSummaryDocs);
  const filingFiscalDocs = useAppSelector((state) => state.filings.filingFiscalDocs);
  const filingExplanatoryDocs = useAppSelector((state) => state.filings.filingExplanatoryDocs);
  const filingGPRODocs = useAppSelector((state) => state.filings.filingGPRODocs);
  const filingCoverLetterDocs = useAppSelector((state) => state.filings.filingCoverLetterDocs);
  const filingCertificateOfAdoptionDocs = useAppSelector((state) => state.filings.filingCertificateOfAdoptionDocs);

  const dispatch = useAppDispatch();

  useEffect(() => {
    getSupportingDocs();
  }, []);

  // #region file upload
  /**
   * @description - handles the creation of a filing supporting document record
   * @param file - this gets sent back from the file upload component
   * @param type
   */
  const saveAdditionalDoc = async (file: any, type: DocumentType) => {
    let supportingDoc: filingSupportingDocument = {
      filingId: filing?.id!,
      documentTypeId: type,
      containerName: 'filing-documents',
      blobName: file.blobName,
      uploadedBy: 'system',
      originalName: file.fileName,
    };

    await filingSupportingDocAPI
      .createSupportingDoc(supportingDoc)
      .then(() => {
        addNotification({
          type: 'success',
          message: `Supporting document was saved successfully to the filing`,
        });
        getSupportingDocs();
      })
      .catch((error: any) => {
        addNotification({
          type: 'error',
          message: `Supporting document was unable to save. ${error.message}`,
        });
      });
  };

  const deleteAdditionalDoc = async (file: any) => {
    await filingSupportingDocAPI.deleteByBlobName(file[0].blobName);
    dispatch(getFilingSupportingDocs(filing.id!))
  };

  const getSupportingDocs = async () => {
    dispatch(getFilingSupportingDocs(filing.id!));
  };

  const handleFileUploadResponseMessage = (message: string, type: 'error' | 'success') => {
    addNotification({
      type: type,
      message: message,
    });
  };
  // #endregion

  return {
    // variables
    filingSummaryDocs,
    filingSupportingDocs,
    filingHearingDocs,
    filingAffidavitDocs,
    filingFiscalDocs,
    filingExplanatoryDocs,
    filingGPRODocs,
    filingCoverLetterDocs,
    filingCertificateOfAdoptionDocs,
    // functions
    handleFileUploadResponseMessage,
    saveAdditionalDoc,
    deleteAdditionalDoc,
  };
};
